import PropTypes from 'prop-types';
import { createContext, useContext, useState, useMemo } from 'react';


const activeTabContext = createContext({
    activeTab: 0,
    setActiveTab: () => { }
});

export const ActiveTabProvider = ({ children }) => {
    const [activeTab, setActiveTab] = useState(0);
    const value = useMemo(() => ({ activeTab, setActiveTab }), [activeTab]);
    return (
        <activeTabContext.Provider value={value}>
            {children}
        </activeTabContext.Provider>
    );
}

export default activeTabContext;

ActiveTabProvider.propTypes = {
    children: PropTypes.node.isRequired
};

export const useActiveTab = () => {
    return useContext(activeTabContext);
}
